import { useEffect, useState } from "react";

/** Custom neon cursor. Follows mouse; adds .cursor-hover on interactive elements. */
export default function Cursor() {
  const [pos, setPos] = useState({ x: -100, y: -100 });

  useEffect(() => {
    if (typeof window === "undefined") return;
    const isCoarse = window.matchMedia("(pointer: coarse)").matches;
    if (isCoarse) return;

    const move = (e) => setPos({ x: e.clientX, y: e.clientY });

    const enter = (e) => {
      const t = e.target;
      if (t.closest("a,button,[data-cursor='hover'],input,textarea,select,label")) {
        document.body.classList.add("cursor-hover");
      }
    };
    const leave = () => document.body.classList.remove("cursor-hover");

    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseover", enter);
    window.addEventListener("mouseout", leave);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", enter);
      window.removeEventListener("mouseout", leave);
    };
  }, []);

  return (
    <>
      <div className="cursor-dot" style={{ transform: `translate(${pos.x}px, ${pos.y}px) translate(-50%, -50%)` }} />
      <div className="cursor-ring" style={{ transform: `translate(${pos.x}px, ${pos.y}px) translate(-50%, -50%)` }} />
    </>
  );
}
